import Pica from 'pica';

// note - using 'ww' (web workers) in the features list can cause puzzle-piece distortion of images
// ClickUp ticket: https://app.clickup.com/t/86dwb38h2
const pica = Pica({
  features: ['js', 'wasm']
});

// Have to convert to an image object for pica library
const createOriginal = file => new Promise(resolve => {
  const image = new global.window.Image();
  image.onload = async () => {
    await image.decode();
    resolve(image);
  };
  image.src = global.window.URL.createObjectURL(file);
});

// Going with QuadVGA: 1280x960 - same as iPad
export const calculateDimensions = ({
  width,
  height
}, toWidth = 1280, toHeight = 960) => {
  const w = parseInt(width, 10);
  const h = parseInt(height, 10);
  const ratio = w / h;
  return ratio > toWidth / toHeight ? {
    width: toWidth,
    height: Math.round(h / (w / toWidth))
  } : {
    width: Math.round(w / (h / toHeight)),
    height: toHeight
  };
};
const createResizedCanvas = image => {
  const {
    width,
    height
  } = calculateDimensions(image);
  const canvas = global.window.document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  return canvas;
};
const createBrowserCanvases = async file => {
  const original = await createOriginal(file);
  const resizedCanvas = createResizedCanvas(original);
  return {
    original,
    resizedCanvas
  };
};
const createCanvases = (file, createServerCanvases = null) => {
  if (global.window === undefined) {
    return createServerCanvases(file);
  }
  return createBrowserCanvases(file);
};
const resizeImage = async (file, createServerCanvases = null) => {
  const {
    original,
    resizedCanvas
  } = await createCanvases(file, createServerCanvases);
  const result = await pica.resize(original, resizedCanvas);
  return pica.toBlob(result, 'image/jpeg', 0.7);
};
export default resizeImage;